// Frontend JavaScript entry point
import './frontend.css';

/**
 * Good Days Menu Manager - Frontend JavaScript (Pure JS)
 */

document.addEventListener('DOMContentLoaded', function() {
    'use strict';

    // Main frontend object
    const GDMMFrontend = {
        init: function() {
            this.bindEvents();
            this.initializeMenus();
        },

        bindEvents: function() {
            // Search functionality
            document.addEventListener('input', (e) => {
                if (e.target.matches('.gdmm-search-input')) {
                    this.debounce(this.handleSearch.bind(this), 300)(e);
                }
            });

            document.addEventListener('keypress', (e) => {
                if (e.target.matches('.gdmm-search-input') && e.which === 13) {
                    e.preventDefault();
                    this.handleSearch(e);
                }
            });

            // Filter functionality
            document.addEventListener('click', (e) => {
                if (e.target.matches('.gdmm-filter-btn')) {
                    this.handleFilter(e);
                }
            });

            // Clear search on escape
            document.addEventListener('keydown', (e) => {
                if (e.target.matches('.gdmm-search-input') && e.keyCode === 27) {
                    e.target.value = '';
                    this.clearSearch();
                }
            });
        },

        initializeMenus: function() {
            // Add animation classes to categories (alternating left/right)
            // Only animate categories that haven't been animated yet
            const categories = document.querySelectorAll('.gdmm-category:not(.gdmm-slide-from-left):not(.gdmm-slide-from-right)');
            categories.forEach((category, index) => {
                category.style.animationDelay = (index * 0.15) + 's';
                category.classList.add(index % 2 === 0 ? 'gdmm-slide-from-left' : 'gdmm-slide-from-right');
            });

            // Initialize tooltips for dietary tags
            this.initTooltips();
            
            // Initialize image popovers
            this.initImagePopovers();
        },

        initTooltips: function() {
            const dietaryTags = document.querySelectorAll('.gdmm-dietary-tag');
            
            dietaryTags.forEach(tag => {
                const title = tag.getAttribute('title');
                
                if (title) {
                    tag.addEventListener('mouseenter', () => {
                        const tooltip = document.createElement('div');
                        tooltip.className = 'gdmm-tooltip';
                        tooltip.textContent = title;
                        document.body.appendChild(tooltip);
                        
                        const tagRect = tag.getBoundingClientRect();
                        const tagHeight = tag.offsetHeight;
                        
                        Object.assign(tooltip.style, {
                            position: 'absolute',
                            top: (tagRect.top + window.scrollY + tagHeight + 5) + 'px',
                            left: (tagRect.left + window.scrollX + (tag.offsetWidth / 2) - (tooltip.offsetWidth / 2)) + 'px',
                            background: '#333',
                            color: '#fff',
                            padding: '4px 8px',
                            borderRadius: '4px',
                            fontSize: '12px',
                            zIndex: '1000',
                            whiteSpace: 'nowrap',
                            opacity: '0',
                            transition: 'opacity 0.2s ease-in-out'
                        });
                        
                        setTimeout(() => {
                            tooltip.style.opacity = '1';
                        }, 10);
                    });

                    tag.addEventListener('mouseleave', () => {
                        const tooltips = document.querySelectorAll('.gdmm-tooltip');
                        tooltips.forEach(tooltip => tooltip.remove());
                    });
                }
            });
        },
        
        initImagePopovers: function() {
            const itemNames = document.querySelectorAll('.gdmm-item-name.gdmm-has-image');
            
            itemNames.forEach(nameEl => {
                const imageUrl = nameEl.dataset.image;
                if (!imageUrl) return;
                
                // Add visual indicator that item has image
                nameEl.style.cursor = 'pointer';
                nameEl.setAttribute('title', 'Hover to see image');
                
                nameEl.addEventListener('mouseenter', (e) => {
                    // Create popover
                    const popover = document.createElement('div');
                    popover.className = 'gdmm-image-popover';
                    popover.innerHTML = `<img src="${imageUrl}" alt="${nameEl.textContent}" loading="lazy">`;
                    document.body.appendChild(popover);
                    
                    // Position popover
                    const rect = nameEl.getBoundingClientRect();
                    const popoverWidth = 200;
                    const popoverHeight = 150;
                    
                    let left = rect.left + window.scrollX;
                    let top = rect.top + window.scrollY - popoverHeight - 25;
                    
                    // Check if popover would go off screen top
                    if (top < window.scrollY) {
                        top = rect.bottom + window.scrollY + 15;
                    }
                    
                    // Check if popover would go off screen right
                    if (left + popoverWidth > window.innerWidth) {
                        left = window.innerWidth - popoverWidth - 20;
                    }
                    
                    Object.assign(popover.style, {
                        position: 'absolute',
                        top: top + 'px',
                        left: left + 'px',
                        zIndex: '10000',
                        opacity: '0',
                        transform: 'scale(0.9)',
                        transition: 'opacity 0.2s ease, transform 0.2s ease'
                    });
                    
                    // Animate in
                    setTimeout(() => {
                        popover.style.opacity = '1';
                        popover.style.transform = 'scale(1)';
                    }, 10);
                });
                
                nameEl.addEventListener('mouseleave', () => {
                    const popovers = document.querySelectorAll('.gdmm-image-popover');
                    popovers.forEach(popover => {
                        popover.style.opacity = '0';
                        popover.style.transform = 'scale(0.9)';
                        setTimeout(() => popover.remove(), 200);
                    });
                });
            });
        },

        handleSearch: function(e) {
            const input = e.target;
            const searchTerm = input.value.toLowerCase().trim();
            const container = input.closest('.gdmm-menu-container');
            const items = container.querySelectorAll('.gdmm-menu-item');
            const categories = container.querySelectorAll('.gdmm-category');
            const noResults = container.querySelector('.gdmm-no-results');

            if (searchTerm === '') {
                this.clearSearch();
                return;
            }

            let hasResults = false;

            items.forEach(item => {
                const itemName = item.querySelector('.gdmm-item-name')?.textContent.toLowerCase() || '';
                const itemDescription = item.querySelector('.gdmm-item-description')?.textContent.toLowerCase() || '';
                
                if (itemName.includes(searchTerm) || itemDescription.includes(searchTerm)) {
                    item.classList.remove('gdmm-filtered-out');
                    item.classList.add('gdmm-filtered-in');
                    hasResults = true;
                } else {
                    item.classList.remove('gdmm-filtered-in');
                    item.classList.add('gdmm-filtered-out');
                }
            });

            // Hide/show categories based on whether they have visible items
            categories.forEach(category => {
                const visibleItems = category.querySelectorAll('.gdmm-menu-item.gdmm-filtered-in');
                
                if (visibleItems.length > 0) {
                    category.style.display = 'block';
                } else {
                    category.style.display = 'none';
                }
            });

            // Show/hide no results message
            if (noResults) {
                noResults.style.display = hasResults ? 'none' : 'block';
            }

            // Note: URL parameters removed - search now works without affecting browser URL
        },

        handleFilter: function(e) {
            e.preventDefault();
            const button = e.target;
            const filter = button.dataset.filter;
            const container = button.closest('.gdmm-menu-container');
            const items = container.querySelectorAll('.gdmm-menu-item');
            const categories = container.querySelectorAll('.gdmm-category');
            const noResults = container.querySelector('.gdmm-no-results');

            // Update active filter button
            const filterButtons = container.querySelectorAll('.gdmm-filter-btn');
            filterButtons.forEach(btn => btn.classList.remove('gdmm-filter-active'));
            button.classList.add('gdmm-filter-active');

            // Clear search when filtering
            const searchInput = container.querySelector('.gdmm-search-input');
            if (searchInput) searchInput.value = '';

            let hasResults = false;

            if (filter === 'all') {
                items.forEach(item => {
                    item.classList.remove('gdmm-filtered-out');
                    item.classList.add('gdmm-filtered-in');
                });
                categories.forEach(category => category.style.display = 'block');
                if (noResults) noResults.style.display = 'none';
                hasResults = true;
            } else {
                items.forEach(item => {
                    // Convert filter name to camelCase for dataset access
                    const dataKey = filter.replace(/_(.)/g, (match, letter) => letter.toUpperCase());
                    const matches = item.dataset[dataKey] == 1;
                    
                    if (matches) {
                        item.classList.remove('gdmm-filtered-out');
                        item.classList.add('gdmm-filtered-in');
                        hasResults = true;
                    } else {
                        item.classList.remove('gdmm-filtered-in');
                        item.classList.add('gdmm-filtered-out');
                    }
                });

                // Hide/show categories based on whether they have visible items
                categories.forEach(category => {
                    const visibleItems = category.querySelectorAll('.gdmm-menu-item.gdmm-filtered-in');
                    category.style.display = visibleItems.length > 0 ? 'block' : 'none';
                });

                // Show/hide no results message
                if (noResults) {
                    noResults.style.display = hasResults ? 'none' : 'block';
                }
            }

            // Note: URL parameters removed - filters now work without affecting browser URL
        },

        clearSearch: function() {
            const menuItems = document.querySelectorAll('.gdmm-menu-item');
            const categories = document.querySelectorAll('.gdmm-category');
            const noResults = document.querySelectorAll('.gdmm-no-results');
            const filterButtons = document.querySelectorAll('.gdmm-filter-btn');

            menuItems.forEach(item => {
                item.classList.remove('gdmm-filtered-out', 'gdmm-filtered-in');
            });
            
            categories.forEach(category => category.style.display = 'block');
            noResults.forEach(result => result.style.display = 'none');
            
            // Reset filter to 'all'
            filterButtons.forEach(btn => btn.classList.remove('gdmm-filter-active'));
            const allFilterBtn = document.querySelector('.gdmm-filter-btn[data-filter="all"]');
            if (allFilterBtn) allFilterBtn.classList.add('gdmm-filter-active');
        },

        debounce: function(func, wait) {
            let timeout;
            return function executedFunction(...args) {
                const later = () => {
                    clearTimeout(timeout);
                    func.apply(this, args);
                };
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
            };
        },

        // Initialize from URL parameters (both search and filter parameters removed)
        initFromURL: function() {
            // URL parameter initialization removed - search and filters work without URL params
            // This function can be kept for future URL-based features if needed
        },

        // Accessibility enhancements
        enhanceAccessibility: function() {
            // Add ARIA labels
            const searchInputs = document.querySelectorAll('.gdmm-search-input');
            searchInputs.forEach(input => {
                input.setAttribute('aria-label', window.gdmm_frontend?.strings?.search_placeholder || 'Search menu items');
            });

            const filterBtns = document.querySelectorAll('.gdmm-filter-btn');
            filterBtns.forEach(btn => {
                const filter = btn.dataset.filter;
                btn.setAttribute('aria-label', `Filter by ${filter}`);
            });

            // Add keyboard navigation for filters
            filterBtns.forEach(btn => {
                btn.addEventListener('keydown', (e) => {
                    const buttons = Array.from(document.querySelectorAll('.gdmm-filter-btn'));
                    const currentIndex = buttons.indexOf(btn);
                    
                    switch(e.which) {
                        case 37: // Left arrow
                            e.preventDefault();
                            const prevIndex = currentIndex > 0 ? currentIndex - 1 : buttons.length - 1;
                            buttons[prevIndex].focus();
                            break;
                        case 39: // Right arrow
                            e.preventDefault();
                            const nextIndex = currentIndex < buttons.length - 1 ? currentIndex + 1 : 0;
                            buttons[nextIndex].focus();
                            break;
                        case 13: // Enter
                        case 32: // Space
                            e.preventDefault();
                            btn.click();
                            break;
                    }
                });
            });
        },

        // Print functionality
        setupPrint: function() {
            // Add print styles when printing
            window.addEventListener('beforeprint', () => {
                const menuControls = document.querySelectorAll('.gdmm-menu-controls');
                const filteredItems = document.querySelectorAll('.gdmm-menu-item.gdmm-filtered-out');
                
                menuControls.forEach(control => control.style.display = 'none');
                filteredItems.forEach(item => item.style.display = 'none');
            });

            window.addEventListener('afterprint', () => {
                const menuControls = document.querySelectorAll('.gdmm-menu-controls');
                const filteredItems = document.querySelectorAll('.gdmm-menu-item.gdmm-filtered-out');
                
                menuControls.forEach(control => control.style.display = '');
                filteredItems.forEach(item => item.style.display = '');
            });
        }
    };

    // Initialize the frontend
    GDMMFrontend.init();
    GDMMFrontend.enhanceAccessibility();
    GDMMFrontend.setupPrint();
    GDMMFrontend.initFromURL();

    // Handle window resize for responsive tooltips
    window.addEventListener('resize', () => {
        const tooltips = document.querySelectorAll('.gdmm-tooltip');
        tooltips.forEach(tooltip => tooltip.remove());
    });

    // Smooth scrolling for anchor links within menus
    document.addEventListener('click', (e) => {
        if (e.target.matches('a[href^="#gdmm-"]')) {
            e.preventDefault();
            const targetId = e.target.getAttribute('href').substring(1);
            const target = document.getElementById(targetId);
            if (target) {
                const offsetTop = target.getBoundingClientRect().top + window.pageYOffset - 20;
                window.scrollTo({
                    top: offsetTop,
                    behavior: 'smooth'
                });
            }
        }
    });

});

// Add CSS for animations
(function() {
    const style = document.createElement('style');
    style.textContent = `
        .gdmm-tooltip {
            animation: fadeIn 0.2s ease-in-out;
        }
        
        @keyframes fadeIn {
            from { opacity: 0; transform: translateY(-5px); }
            to { opacity: 1; transform: translateY(0); }
        }
        
        .gdmm-slide-from-left {
            animation: slideInFromLeft 0.6s ease-out both;
        }
        
        .gdmm-slide-from-right {
            animation: slideInFromRight 0.6s ease-out both;
        }
        
        @keyframes slideInFromLeft {
            from { 
                opacity: 0; 
                transform: translateX(-60px); 
            }
            to { 
                opacity: 1; 
                transform: translateX(0); 
            }
        }
        
        @keyframes slideInFromRight {
            from { 
                opacity: 0; 
                transform: translateX(60px); 
            }
            to { 
                opacity: 1; 
                transform: translateX(0); 
            }
        }
        
        @media (prefers-reduced-motion: reduce) {
            .gdmm-slide-from-left,
            .gdmm-slide-from-right {
                animation: none;
            }
        }
    `;
    document.head.appendChild(style);
})();
